import hotelEvents from '../config/hotel-events';
export default function HotelsListController(
    $scope,
    $rootScope,
    $stateParams,
    $window,
    $state,
    deviceDetector,
    hotelsFactory,
    basketService,
    userService,
    l10nService,
    hotelSearchResults
) {
    'ngInject';

    const vm = this;
    const HOTELS_TO_DISPLAY_PER_PAGE = 20;
    const regionalSettings = userService && userService.getRegionalSettings();
    const defaultSorting = {
        distance: {text: l10nService.localize('Distance'), value: '0', sortType: 0},
        starRating: {text: l10nService.localize('Star rating'), value: '0', sortType: 0},
        price: {text: l10nService.localize('Price'), value: '0', sortType: 0},
    };

    $scope.filtersApplied = false;
    $scope.params = $stateParams;
    $scope.hotels = [];

    Object.assign(vm, {
        $onInit,
        loadMore,
        isLoadMoreVisible,
        getHotelDetailsUrlParams,
        toggleAllRates,
        isAllRatesVisible,
        isRatesSpinnerVisible,
    });

    function $onInit() {
        subscribe();
        setHotelResults(hotelSearchResults);
        setSorting();
    }

    function setHotelResults(results) {
        const {Hotels, SearchId, Total} = results;
        Object.assign($scope, {
            hotels: Hotels || [],
            searchId: SearchId,
            total: Total,
            showSorting: (deviceDetector.device !== 'iphone' && (Hotels && !!Hotels.length)),
        });
    }

    function getHotelDetailsUrlParams(hotelId) {
        const {searchId, total, minPricePerDay, maxPricePerDay} = hotelsFactory.getSearchResults();
        const {checkInDate, checkOutDate, roomsQuantity,
            occupantsQuantity, cityName, latitude, longitude} = $stateParams;

        const params = {
            hotelId,
            searchId,
            checkInDate,
            checkOutDate,
            roomsQuantity,
            occupantsQuantity,
            cityName,
            latitude,
            longitude,
            searchTotal: total,
            searchMinPrice: minPricePerDay,
            searchMaxPrice: maxPricePerDay,
            altAddress: hotelsFactory.altAddress,

        };
        return params;
    }

    function loadMore() {
        hotelsFactory.loadMoreHotels()
            .then((loadedHotels) => {
                $scope.hotels = [...$scope.hotels, ...loadedHotels];
                $scope.total = hotelsFactory.getTotalCount();
            });
    }

    function isLoadMoreVisible() {
        const hotelsCount = $scope.hotels ? $scope.hotels.length : 0;
        return hotelsCount >= HOTELS_TO_DISPLAY_PER_PAGE
            && hotelsCount < $scope.total;
    }

    function subscribe() {
        $scope.$on(hotelEvents.HOTELS_APPLY_FILTERS, applyFilters);
        $scope.$on(hotelEvents.HOTELS_TRIGGER_HOTELS_SORTING, () => $scope.showSorting = !$scope.showSorting);
    }

    function applyFilters(event, filters) {
        hotelsFactory.applyFilters(filters)
            .then(setHotels);
    }

    $scope.order = function(sortExpression) {
        if (!$scope.hotels || !$scope.hotels.length) {
            return;
        }
        hotelsFactory.getSortHotels(sortExpression)
            .then(setHotels);
    };

    function setHotels(results) {
        const {Hotels, Markers} = results;
        $scope.hotels = Hotels;
        $scope.total = hotelsFactory.getTotalCount();
        hotelSearchResults.Markers = Markers;
    }

    function setSorting() { // eslint-disable-line
        $scope.hotelsData = {
            distanceSort: [
                {text: l10nService.localize('Distance: nearest'), value: '2', sortType: 1},
                {text: l10nService.localize('Distance: furthest'), value: '1', sortType: 2},
            ],
            distanceSortSelected: {text: l10nService.localize('Distance: nearest'), value: '2', sortType: 1},
            starRatingSort: [
                {text: l10nService.localize('Stars rating: 1-5'), value: '2', sortType: 3},
                {text: l10nService.localize('Stars rating: 5-1'), value: '1', sortType: 4},
            ],
            starRatingSortSelected: angular.copy(defaultSorting.starRating),
            priceSort: [
                {text: l10nService.localize('Price: low-high'), value: '2', sortType: 5},
                {text: l10nService.localize('Price: high-low'), value: '1', sortType: 6},
            ],
            priceSortSelected: angular.copy(defaultSorting.price),
        };

        const selectedSort = +$stateParams.HotelSorting || 0;

        switch (selectedSort) {
            case 1:
            case 2:
                const distanceIndex = selectedSort === 1 ? 0 : 1;
                $scope.hotelsData.distanceSortSelected = angular.copy($scope.hotelsData.distanceSort[distanceIndex]);
                break;
            case 3:
            case 4:
                const ratingIndex = selectedSort === 3 ? 0 : 1;
                $scope.hotelsData.starRatingSortSelected = angular.copy($scope.hotelsData.starRatingSort[ratingIndex]);
                break;
            case 5:
            case 6:
                const priceIndex = selectedSort === 1 ? 0 : 1;
                $scope.hotelsData.priceSortSelected = angular.copy($scope.hotelsData.priceSort[priceIndex]);
                break;
        }

    }

    $scope.diffDates
        = moment($scope.params.checkOutDate, regionalSettings.dateFormat)
            .diff(moment($scope.params.checkInDate, regionalSettings.dateFormat), 'days');

    $scope.addToBasket = basketService.addHotel.bind(null);

    $scope.clearHotelsFilters = function() {
        $rootScope.$broadcast(hotelEvents.HOTELS_CLEAR_HOTEL_FILTERS);
        $scope.filtersApplied = false;
    };

    $scope.$watch('hotelsData.distanceSortSelected.value', function(newValue, oldValue) {
        if ((newValue === oldValue) || (+newValue === 0)) {
            return false;
        }

        _.extend($scope.hotelsData.starRatingSortSelected, defaultSorting.starRating);
        _.extend($scope.hotelsData.priceSortSelected, defaultSorting.price);

        $scope.order($scope.hotelsData.distanceSortSelected.sortType);
    });

    $scope.$watch('hotelsData.starRatingSortSelected.value', function(newValue, oldValue) {
        if ((newValue === oldValue) || (+newValue === 0)) {
            return false;
        }

        _.extend($scope.hotelsData.distanceSortSelected, defaultSorting.distance);
        _.extend($scope.hotelsData.priceSortSelected, defaultSorting.price);

        $scope.order($scope.hotelsData.starRatingSortSelected.sortType);
    });

    $scope.$watch('hotelsData.priceSortSelected.value', function(newValue, oldValue) {
        if ((newValue === oldValue) || (+newValue === 0)) {
            return false;
        }

        _.extend($scope.hotelsData.distanceSortSelected, defaultSorting.distance);
        _.extend($scope.hotelsData.starRatingSortSelected, defaultSorting.starRating);

        $scope.order($scope.hotelsData.priceSortSelected.sortType);
    });

    function isAllRatesVisible(hotel) {
        return (hotel.isAllRatesOpened && hotel.isAllAvailableRatesLoaded && hotel.MoreRoomsAvailable)
            || (!hotel.MoreRoomsAvailable && hotel.isAllRatesOpened);
    }

    function isRatesSpinnerVisible(hotel) {
        return hotel.isAllRatesOpened
            && hotel.MoreRoomsAvailable
            && !hotel.isAllAvailableRatesLoaded;
    }

    function toggleAllRates(hotel) {
        hotel.isAllRatesOpened = !hotel.isAllRatesOpened;

        if (hotel.MoreRoomsAvailable && hotel.isAllRatesOpened && !hotel.isAllAvailableRatesLoaded) {
            hotel.areAddToBasketButtonsDisabled = true;
            const {searchId} = hotelsFactory.getSearchResults();
            const {occupantsQuantity} = $stateParams;
            const hotelId = hotel.Id;

            hotelsFactory.getMoreRoomsAvailable(hotelId, searchId, occupantsQuantity)
                .then((rooms) => {
                    const roomsPrices = rooms.map((room) => room.RequestedPrice);

                    hotel.Rooms = rooms;
                    hotel.TotalPrice = Math.min(...roomsPrices);
                    hotel.AveragePricePerNight = hotel.TotalPrice / $scope.diffDates;
                    hotel.isAllAvailableRatesLoaded = true;
                    hotel.areAddToBasketButtonsDisabled = false;
                })
                .catch(() => hotel.isAllAvailableRatesLoaded = true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotels-list-controller.js